export const MONTHS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const TRANSACTION_MESSAGE_TYPE = [
  { displayName: 'All', value: '' },
  { displayName: 'Order confirmation', value: 'order_confirmation' },
  { displayName: 'Awaiting payment', value: 'payment_awaiting' },
  { displayName: 'Awaiting payment reminder', value: 'awaiting_order_reminder' },
  { displayName: 'Payment Failure', value: 'payment_failure' },
  { displayName: 'Downline payment', value: 'downline_payment' },
  { displayName: 'Bonus Payment', value: 'bonus' },
  { displayName: 'ABO - POOL', value: 'ABO_POOL' },
  { displayName: 'GMN - Create new profile', value: 'gmn_newprofile' },
  { displayName: 'GMN - Edit profile', value: 'gmn_editprofile' },
  { displayName: 'GMN - Order confirmation', value: 'gmn_orderconfirmation' },
  { displayName: 'GMN - Awaiting order', value: 'gmn_awaitingorder' },
  { displayName: 'GMN - Profile cancelled', value: 'gmn_profilecancelled' },
  { displayName: 'GMN - All active profiles', value: 'gmn_allactiveprofiles' },
  { displayName: 'GMN - Active profiles', value: 'gmn_activeprofiles' },
  { displayName: 'GMN - Daily greeting', value: 'gmn_greeting' },
  { displayName: 'GMN - Daily checklist', value: 'GMN_CHECKLIST' },
  { displayName: 'GMN - Performance', value: 'GMN_PERFORMANCE' },
  { displayName: 'GMN - Privilege', value: 'GMN_PRIVILEGE' },
  { displayName: 'GMN - Reminder', value: 'GMN_REMINDER' },
  { displayName: 'LON - Registration', value: 'lon_registration' },
  { displayName: 'LON - Renewal reminder', value: 'lon_renewal' },
  { displayName: 'Individual Challenge', value: 'INDIVIDUAL_CHALLENGE' },
  { displayName: 'Me Buddy Challenge', value: 'ME_BUDDY_CHALLENGE' },
  { displayName: 'Team Challenge', value: 'TEAM_CHALLENGE' },
  { displayName: 'Artistry Notification', value: 'ARTISTRY_NOTIFICATION' },
]

export const MESSAGE_DELIVERY_STATUS = [
  'Total',
  'Pending',
  'Delivered',
  'Resend',
  'Failed'
]